/* __next_internal_client_entry_do_not_use__ Minimize auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { createSVGIcon } from "../util";
var VIEWBOX = "0 0 24 24";
/**
 * @trackcomponent
 * @donotsync shifts upwards (@quinlan.sokol)
 */ export var Minimize = createSVGIcon(/*#__PURE__*/ _jsxs(_Fragment, {
    children: [
        /*#__PURE__*/ _jsx("path", {
            d: "M1 23.2863L9.57143 14.7148",
            stroke: "currentColor"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M2.71436 14.7148H9.5715V21.572",
            stroke: "currentColor"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M23.2858 1L14.7144 9.57143",
            stroke: "currentColor"
        }),
        /*#__PURE__*/ _jsx("path", {
            d: "M21.5715 9.57199H14.7144V2.71484",
            stroke: "currentColor"
        })
    ]
}), "Minimize", function(strictLocalize) {
    return {
        viewBox: VIEWBOX,
        titleAccess: strictLocalize({
            id: "U3OUDy",
            defaultMessage: [
                {
                    type: 0,
                    value: "Minimize"
                }
            ]
        }),
        fill: "none"
    };
});
